import { render, staticRenderFns } from "./dialog-sessionexpired.vue?vue&type=template&id=8ff71118&"
import script from "./dialog-sessionexpired.vue?vue&type=script&lang=js&"
export * from "./dialog-sessionexpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports